const Events = {
  onMcPollingStart: 'onMcPollingStart',
  onMcPollingDone: 'onMcPollingDone',
  onMcPollingCancelled: 'onMcPollingCancelled',
  onMcPollingError: 'onMcPollingError',
};

export default Events;
